export default {
  haulers: 'Перевозчики',
  setup: 'Настройка',
  driverExperience: 'Опыт водителя',
  users: 'Пользователи',
};
